import { makeStyles } from '@material-ui/core';
import themes from 'constants/themes';
import {
    checkGenderFilter,
    checkBodyShapeFilter,
    checkBodyTypeFilter,
    IFilterItem,
    checkExpertiseFilter,
    checkLevelFilter,
    checkBrandsFilter,
} from 'redux/filter/filterSlice';
import { RootState, useAppDispatch, useAppSelector } from 'redux/store';
import { StyledSelectOption } from 'component/StandardDropDownCheckBox';
import { WidgetCode } from 'component/popup/constant';
import utils from 'utils/utils';

const FilterCommonWidget = ({ setTriggerUpdateSearch, type }) => {
    const classes = useStyles();
    const dispatch = useAppDispatch();
    const {
        genderFilterList = [],
        bodyShapeFilterList = [],
        bodyTypeFilterList = [],
        purposeFilterList = [],
        expertiseFilterList = [],
        levelFilterList = [],
        brandFilterList = [],
    } = useAppSelector((state: RootState) => state.filter);

    const handleChange = (item: IFilterItem<string>) => {
        switch (type) {
        case WidgetCode.GenderFilterWidget:
            dispatch(checkGenderFilter(item));
            break;
        case WidgetCode.BodyShapeFilterWidget:
            dispatch(checkBodyShapeFilter(item));
            break;
        case WidgetCode.BodyTypeFilterWidget:
            dispatch(checkBodyTypeFilter(item));
            break;
        case WidgetCode.PurposeFilterWidget:
            // dispatch(checkBodyTypeFilter(item));
            break;
        case WidgetCode.ExpertiseFilterWidget:
            dispatch(checkExpertiseFilter(item));
            break;
        case WidgetCode.LevelFilterWidget:
            dispatch(checkLevelFilter(item));
            break;
        case WidgetCode.BrandsFilterWidget:
            dispatch(checkBrandsFilter(item));
            break;
        default:
            break;
        }
        setTriggerUpdateSearch(true);
    };

    return (
        <div className={classes.sortWrap}>
            {type === WidgetCode.GenderFilterWidget
                ? genderFilterList.map((item: IFilterItem<string>) => (
                    <StyledSelectOption
                        key={item.value}
                        label={item.title}
                        value={item.value}
                        isActive={item.isActive || false}
                        handleChange={() => handleChange(item)}
                        style={{ padding: 0 }}
                    />
                ))
                : type === WidgetCode.PurposeFilterWidget
                    ? purposeFilterList
                        .slice()
                        .sort(utils.sortFilterObjectArray)
                        .map((item: IFilterItem<string>) => (
                            <StyledSelectOption
                                key={item.value}
                                label={item.title}
                                value={item.value}
                                isActive={item.isActive || false}
                                handleChange={() => handleChange(item)}
                                style={{ padding: 0 }}
                            />
                        ))
                    : type === WidgetCode.BodyShapeFilterWidget
                        ? bodyShapeFilterList
                            .slice()
                            .sort(utils.sortFilterObjectArray)
                            .map((item: IFilterItem<string>) => (
                                <StyledSelectOption
                                    key={item.value}
                                    label={item.title}
                                    value={item.value}
                                    isActive={item.isActive || false}
                                    handleChange={() => handleChange(item)}
                                    style={{ padding: 0 }}
                                />
                            ))
                        : type === WidgetCode.ExpertiseFilterWidget
                            ? expertiseFilterList.map((item: IFilterItem<string>) => (
                                <StyledSelectOption
                                    key={item.value}
                                    label={item.title}
                                    value={item.value}
                                    isActive={item.isActive || false}
                                    handleChange={() => handleChange(item)}
                                    style={{ padding: 0 }}
                                />
                            ))
                            : type === WidgetCode.LevelFilterWidget
                                ? levelFilterList.map((item: IFilterItem<string>) => (
                                    <StyledSelectOption
                                        key={item.value}
                                        label={item.title}
                                        value={item.value}
                                        isActive={item.isActive || false}
                                        handleChange={() => handleChange(item)}
                                        style={{ padding: 0 }}
                                    />
                                ))
                                : type === WidgetCode.BodyTypeFilterWidget
                                    ? bodyTypeFilterList.map((item: IFilterItem<string>) => (
                                        <StyledSelectOption
                                            key={item.value}
                                            label={item.title}
                                            value={item.value}
                                            isActive={item.isActive || false}
                                            handleChange={() => handleChange(item)}
                                            style={{ padding: 0 }}
                                        />
                                    ))
                                    : type === WidgetCode.BrandsFilterWidget &&
                  brandFilterList
                      .slice()
                      .sort(utils.sortFilterObjectArray)
                      .map((item: IFilterItem<string>) => (
                          <StyledSelectOption
                              key={item.value}
                              label={item.title}
                              value={item.value}
                              isActive={item.isActive || false}
                              handleChange={() => handleChange(item)}
                              style={{ padding: 0 }}
                          />
                      ))}
        </div>
    );
};

export default FilterCommonWidget;

const useStyles = makeStyles(() => ({
    sortWrap: {
        marginTop: 20,
    },
    filterTitle: {
        marginTop: 24,
        fontSize: 18,
        fontWeight: 600,
        color: themes.palette.primary.main,
    },
    selectedItem: {
        background: '#E8F0F1',
    },
}));
